import React from "react";
import { Link } from "react-router-dom";
import "./AIandReport.css";

const AIandReport = () => {
    return (
        <div className="ai-report-container">
            <h2 className="ai-report-title">AI Analytics</h2>
            <div className="ai-report-buttons">
                <Link to="/SentimentAnalysis">
                    <button>EmotionFlow AI</button>
                </Link>
                <Link to="/churn">
                    <button>Smart AI Churn Insights</button>
                </Link>
                <Link to="/chatbot">
                    <button>Chatbot</button>
                </Link>
                <Link to="/Future">
                    <button>Future</button>
                </Link>
            </div>
        </div>
    );
};

export default AIandReport;
